<div class="dashboard-custom-select__wrapper">
  <div class="selector" #selectorElement [ngClass]="{'active': isActive, 'disabled': disabled}" (click)="toggleActive()"
    tabindex="0" (focus)="focusGained($event)" (blur)="focusLost($event)" (keydown.arrowup)="arrowUp($event)"
    (keydown.arrowdown)="arrowDown($event)" (keydown.enter)="enterPressed($event)" (keydown.tab)="tabPress($event)">

    <div class="value">
      <span class="placeholder" *ngIf="!innerValue">{{placeholder}}</span>
      <div class="selected-value">{{getDisplayValue(innerValue)}}</div>
    </div>

    <div class="value-list" *ngIf="isActive">
      <div class="item" *ngFor="let item of values;index as i">
        <div class="selection" (click)="selectItem(item)" [ngClass]="{'over': item.isOver}"
          [ngStyle]="{'border-bottom': i<values.length-1 ? values[i+1]['group'] !== item.group ? '1px solid #DFE1E9':'' : null}">
          {{item.value}}
        </div>

        <div class="item" *ngFor="let inner of item.items">
          <div class="selection" (click)="selectItem(inner)">{{inner.value}}</div>
        </div>
      </div>
    </div>
  </div>
  <label class="select-label">{{floatingLabel}}</label>
</div>
